import { createIcon, defaultProps, Icon } from "@chakra-ui/react";
import { motion } from "framer-motion";
import React from "react";
import { Children } from "react";
import useColorSwitcher from "../../../utils/hooks/useColorSwitcher";

const groupVariants = {
  hidden: {
    fillOpacity: -25,
  },
  visible: {
    fillOpacity: 1,

    transition: {
      // delay: 0.5,
      duration: 2.5,
      ease: "easeInOut",
    },
  },
};

const pathVariants = {
  hidden: {
    pathLength: 0,
    pathOffset: 1,
    opacity: 0,
  },
  visible: {
    pathLength: 1,
    pathOffset: 0,
    opacity: 1,
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
};

const LogoBase = createIcon({
  defaultProps,
  displayName: "LogoBase",
  viewBox: "0 0 144 191",
  path: (
    <motion.g variants={groupVariants} initial="hidden" animate="visible">
      <motion.path //
        d="M23.536 190.096c2.688 0 5.088-.384 7.2-1.152 6.912-1.92 14.016-7.2 21.312-15.84 6.336-7.488 12.48-16.896 18.432-28.224a281.811 281.811 0 0010.368-21.888c14.208-6.72 24.576-12.576 31.104-17.568 11.712-8.832 21.888-21.216 30.528-37.152 1.344-2.496 1.632-5.088.864-7.776-.768-2.688-2.4-4.704-4.896-6.048-2.688-1.344-5.376-1.632-8.064-.864-2.496.768-4.512 2.4-6.048 4.896-8.832 16.128-19.872 28.224-33.12 36.288 1.536-4.608 3.648-11.712 6.336-21.312l2.304-3.168c8.832-11.136 11.424-19.872 7.776-26.208-1.344-2.304-2.976-3.84-4.896-4.608 2.496.192 4.8-.384 6.912-1.728 2.112-1.536 3.456-3.648 4.032-6.336 2.112-11.904-1.344-20.64-10.368-26.208C96.784.976 88.624-.368 78.832 1.168c-9.6 1.344-18.816 5.184-27.648 11.52-10.56 7.68-20.928 18.144-31.104 31.392C8.368 59.632 1.936 73.456.784 85.552c-.96 9.792 1.632 17.856 7.776 24.192 6.336 6.912 14.112 10.08 23.328 9.504 10.368-.576 21.888-5.664 34.56-15.264-.192.384-.48 1.056-.864 2.016-.192.768-.384 1.344-.576 1.728l-13.824 6.336c-14.208 7.296-25.344 14.976-33.408 23.04-9.792 9.408-15.264 18.432-16.416 27.072-1.152 7.872 1.056 14.496 6.624 19.872 4.608 4.032 9.792 6.048 15.552 6.048zM85.744 21.04c2.88 0 5.088.48 6.624 1.44 1.344.384 1.728 2.016 1.152 4.896-.96 4.992.864 8.64 5.472 10.944-1.344 0-2.304.096-2.88.288-7.872.96-13.344 7.968-16.416 21.024l-.864 4.32c-8.256 9.6-16.8 17.76-25.632 24.48-8.832 6.72-16.224 10.176-22.176 10.368-3.072.192-5.568-.768-7.488-2.88-1.92-2.304-2.688-5.184-2.304-8.64.768-8.448 5.664-18.528 14.688-30.24 9.216-11.904 18.336-21.12 27.36-27.648 7.488-5.568 14.976-8.352 22.464-8.352zM51.472 137.104c-10.368 19.2-19.296 29.952-26.784 32.256-1.152.384-2.112.192-2.88-.576-.384-.384-.48-.96-.288-1.728.576-3.456 3.456-7.968 8.64-13.536 5.184-5.568 12.288-11.04 21.312-16.416z"
        variants={pathVariants}
      />
    </motion.g>
  ),
});

const Logo = ({ boxSize = "64px", ...props }) => {
  const { colorLight, colorDark } = useColorSwitcher();
  return <Icon {...props} fill={colorDark} boxSize={boxSize} as={LogoBase} />;
};

export default Logo;
